import Vue from 'vue'
import hash from 'object-hash'
import { createPlatformState, platformAction, platformGetters, platformMutations } from '~/helpers/store'

export default {
  state: () => ({ ...createPlatformState(), venues: {} }),
  actions: {
    async fetchTours ({ commit }, id) {
      const tours = await platformAction({
        client: this.$api.content.houseTours,
        method: 'getAll',
        params: {
          filter: {
            venue_id: id
          }
        },
        commit,
        logError: this.$logError,
        include: []
      })
      commit('saveSearch', { id, tours })
    }
  },
  getters: {
    ...platformGetters,
    getToursByHouse: s => id => {
      const hashedSearch = hash(id)
      const thisSearch = s.venues[hashedSearch]

      if (!thisSearch) {
        return []
      }

      return thisSearch.tours
    }
  },

  mutations: {
    ...platformMutations,
    saveSearch: (s, { id, tours }) => {
      const hashedSearch = hash(id)
      const search = { tours }
      Vue.set(s.venues, hashedSearch, search)
    }
  }
}
